import { disabledProps, styled } from "../../../styled-components";

export const FormElementStyle = styled.div<{ isEnabled: boolean }>`
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    display: flex;
    flex-direction: column;

    .labels {
        display: flex;
        align-items: flex-end;

        margin-bottom: 8px;

        .label {
            flex-grow: 1;
            ${p => p.theme.fontStyles.Header5};
            color: ${p => p.theme.fgColorMedium};
        }
        span {
            ${p => p.theme.fontStyles.Header7};
            color: ${p => p.theme.fgColorLight};
        }
    }

    caption {
        margin-top: 8px;
        text-align: start;
        ${p => p.theme.fontStyles.Caption6};
        color: ${p => p.theme.fgColorLight};
    }

    &.error {
        caption {
            color: ${p => p.theme.destroyColor};
        }
    }

    ${p => !p.isEnabled && disabledProps}
`;
